module.exports = __webpack_public_path__ + "static/media/code-commit.b24b5e6e.svg";